<template>
  <div class="texture">
      <label>{{label}}</label>
      <div class="textures_toggle">
        <div class="texture__btn" @click="showList = !showList">
          <img v-if="selectedTexture" :src="selectedTexture" alt="">
          <span v-else></span>
        </div>
      <ul v-if="showList" class="texture__list">
          <li class="default__texture"  @click="select(null)"><span></span></li>
          <li v-for="(texture,index) in textures" :key="index" @click="select(texture)">
            <img :src="texture" alt="" srcset="">
          </li>
          <li @click="uplaod" class="add__texture">
              <!-- <i class="fas fa-plus"></i> -->
              <i class="fas fa-upload"></i>
              
          </li>
      </ul>
      </div>
      <Upload ref="uploader" type="image" :accptedFormat="['jpg','png','jpeg']" class="upload" @input="getTexture"/>
  </div>
</template>

<script>
import Upload from './Upload.vue'
export default {
  components : { Upload },
     props : {
        id : { type : String | Number, default:'color'},
        name : { type : String, default:'color'},
        label : { type : String, default:'color'},
        value : { type : String, default:null},
    },
    data(){
      return {
          showList : false,
          textures : [],
          selectedTexture : null,
      }
    },
    watch : {
      value(val) {
        this.selectedTexture = val
      },
    },
    methods : {
      uplaod(){ this.$refs.uploader.upload();},
      getTexture(file){
         let reader = new FileReader();
          reader.readAsDataURL(file.imageFile);
          reader.onload = (e) => {
            this.textures.push(e.target.result)
            }
      },
      select(texture){
        this.selectedTexture = texture
        this.$emit('input',this.selectedTexture)
        // this.showList = false
      }
    }

}
</script>

<style lang="scss" scoped>
  .texture {
    padding : 1rem 0 ;
    display :flex;
    align-items : center;
  }
  .textures_toggle{
    position : relative;
    display: flex;
    align-items: center;
  }
  .texture__btn {
    background-color: #ffffff;
    box-shadow: 0 0 1px black;
    border-radius: .3rem;
    width : 3rem;
    height : 3rem;
    margin : 0 .5rem;
    position : relative;
    display: flex;
    align-items: center;
    cursor : pointer;
    span{
      content: "";
      position: absolute;
      top: -6px;
      bottom: -7px;
      left: 46%;
      border: 1px solid rgba(255, 0, 0, 0.5);
      background-color : rgba(255, 0, 0, 0.397);
      transform : rotate(-40deg)
    }
  }
  .texture__list {
    position : absolute;
    display : flex;
    flex-wrap: wrap;
    width : 12rem;
    padding : 0.5rem;
    min-height: 8rem;
    box-shadow: 0 0 1px black;
    background-color: #ffffff;
    border-radius: .3rem;
    top : 3.5rem;
    left : 0;
    z-index: 9999;
  }
  li {
    border-radius: .3rem;
    margin : .2rem !important;
    width: 3rem;
    height: 3rem;
    list-style: none;
    cursor: pointer;
    &:hover {
      opacity: .8;
    }
  }
  img {
    border-radius: .3rem;
    width : 100%;
    height : 100%;
    object-fit:cover;
    box-shadow: 0 0 1px black;
  }
  .default__texture {
    @extend .texture__btn;
    min-width: 3rem;
    height: 3rem;
    span {
      top: -7px;
      bottom: -5px;
      left: 46%;
    }
  }
  .add__texture {
    @extend .texture__btn;
    min-width: 3rem;
    height: 3rem;
    display : flex;
    align-items : center;
    justify-content : center;
    background-color : #1979e7c0;
    color : #ffffff;
    &:hover {
      background-color : #1979e78a;
      
    }
  }
  .upload {
    display : none;
  }

</style>


// WEBPACK FOOTER //
// src/components/global/TexturePicker.vue